var $ = require('jQuery');
var Vue = require('vue');
var Multiselect = require('vue-bootstrap').Multiselect;
var FileTypes = require('../../lib/filetypes');

module.exports = function() {
    new FileTypes();

    new Vue({
        el: '#category-selector',
        components: {
            'multiselect': Multiselect
        }
    });

    var toggleOptions = function() {
        var type = $('input:radio[name="type"]:checked');

        if (type.length) {
            var options = $('.'+type.val().toLowerCase()+'-options');

            $('.options').addClass('hidden');

            if (options.length) {
                options.removeClass('hidden');
            }
        }
    };

    // Whenever a category selection is made (aka, all, or select), we need to show the appropriate container
    var categorySelection = function () {
        var value = $('input[name=categoryOption]:checked').val();

        if (value == 'select') {
            $('#categorySelectionContainer').show();
        } else {
            $('#categorySelectionContainer').hide();
        }
    };

    $('input:radio[name="type"]').click(function() {
        toggleOptions();
    });

    $('input[name=categoryOption]').change(categorySelection);

    toggleOptions();
    categorySelection();
};
